import { createContext, createElement } from "react";

export const FeatureContext = createContext("common");
export const FeatureProvider = ({ namespace, children }) => {
  return createElement(FeatureContext.Provider, { value: namespace }, children);
};
